import styled from '@emotion/styled'

import { CONFIG } from '@/styles/emotion.config'

import type { CarouselItemSize } from '../types'

export const CarouselStyles = styled.div`
  display: block;
  overflow-x: auto;
  overflow-y: hidden;
  position: relative;
  transform: translate3d(0, 0, 0);
  min-width: 100%;
  max-width: 100%;
`

export const CarouselWrapperStyles = styled.div`
  display: block;
`

export const CarouselItemStyles = styled.li<{
  itemGap: number
  contentAlign: string
  size: Pick<CarouselItemSize, 'width' | 'height'>
}>(
  (props) => `
  display: inline-flex;
  overflow: hidden;
  flex: 1 0 auto;
  flex-wrap: nowrap;
  white-space: normal;
  justify-content: center;
  align-items: center;
  margin-left: ${props.itemGap && `var(--space-${props.itemGap})`};
  margin-right: ${props.itemGap && `var(--space-${props.itemGap})`};
  scroll-snap-align: center;
  width: 50%;
  min-width: ${props.size.width}px;
  height: ${props.size.height}px;

  &:first-of-type {
    margin-left: ${props.size.width}px;
  }

  &:last-child {
    margin-right: ${props.size.width}px;
  }
`,
)

export const CarouselInnerStyles = styled.ol<{ smoothness: boolean }>(
  ({ smoothness }) => `
  display: flex;
  align-items: center;
  overflow-x: auto;
  flex-wrap: nowrap;
  max-width: 1440px;
  margin: 0 auto;
  scroll-behavior: ${smoothness ? 'smooth' : 'auto'};
  scroll-snap-type: x mandatory;

  /* Disable scrollbar Firefox */
  @-moz-document url-prefix() {
    scrollbar-width: none;
  }

  /* Disable scrollbar Chrome, Webkit */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Fix Safari: force margin-left in last item */
  &:after {
    content: "''";
    display: block;
    width: 50%;
  }
`,
)

export const CarouselActionsStyles = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: var(--space-2);
  padding-bottom: var(--space-2);
  margin: 0 auto;

  ${CONFIG.media.md} {
    max-width: 1000px;
  }

  .carousel-button {
    padding-right: var(--space-2);
    padding-left: var(--space-2);
    min-width: auto;
    border-radius: var(--radii-default);
    margin: 0 auto;
  }
`

export const MediaItemStyles = styled.a<{ size: CarouselItemSize }>(
  ({ size }) => `
  transition: 0.6s ease;
  transition-property: width, height;
  width: ${size.width}px;
  height: ${size.height}px;

  &.--active {
    width: ${size.activeWidth}px;
    height: ${size.activeHeight}px;
  }

  span {
    transition: padding 0.6s ease;
  }
`,
)
